import { Button, Card, CardContent, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { NoteService } from '../../Services/note.service';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';

const EditNote = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const [notes, setNotes] = useState({})
    const [code, setCode] = useState('');
    const [note, setNote] = useState('');
    const [image, setImage] = useState();
    const [imageReview, setImageReview] = useState();

    useEffect(() => {
        getNoteById()
    }, []);

    const getNoteById = async () => {
        const noteData = await NoteService.GetNoteId(id);
        setNotes(noteData)
        setCode(noteData.code)
        setNote(noteData.note)
        setImageReview(`${process.env.REACT_APP_IMAGE}${noteData.image}`);

    };

    const handleEditClick = async () => {
        const form = new FormData();
        form.append('code', code);
        form.append('note', note);
        form.append('image', image);
        try {
            await NoteService.EditNode(id, form);
            navigate(`/notes`, { replace: true, state: '/notes' });
            enqueueSnackbar('Cập nhật thành công', { variant: 'success' });
        } catch (error) {
            console.log(error)
        }
    }

    const handleCancelClick = () => {
        navigate(-1);
    };

    const handleAvatarChange = (e) => {
        const img = e.target.files[0];
        const review = URL.createObjectURL(img);
        setImageReview(review);
        setImage(img);
    };


    return (
        <Page title="Create event">
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Sửa note
                    </Typography>
                    <Stack direction={'row'} spacing={1}>
                        <Button
                            type="button"
                            onClick={handleCancelClick}
                            color="error"
                            variant="contained"
                            startIcon={<Iconify icon="iconoir:cancel" />}
                        >
                            Cancel
                        </Button>
                        <Button
                            //   disabled={isSubmitting} 
                            onClick={handleEditClick}
                            type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                            Save
                        </Button>
                    </Stack>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                            <Grid item xs={12} md={8}>
                                <Stack spacing={3}>
                                    <TextField id="outlined-basic" label="Code" variant="outlined"
                                        value={code}
                                        onChange={e => setCode(e.target.value)}
                                    />
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Ghi chú"
                                        multiline
                                        rows={4}
                                        value={note}
                                        onChange={e => setNote(e.target.value)}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Button
                                    // disabled={isSubmitting}
                                    sx={{ border: '1px dashed gray' }}
                                    color="primary"
                                    aria-label="upload picture"
                                    component="label"
                                >
                                    <input
                                        onChange={handleAvatarChange}
                                        hidden accept="image/*" type="file" />
                                    {imageReview ? (
                                        <img
                                            src={imageReview}
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <img
                                            src="/static/noimage.jpeg"
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    )}
                                </Button>
                                <Typography variant="body2" display="block" sx={{opacity: '0.6'}}>Kích thước: 500x760</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    )
}

export default EditNote